import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { RoleForm } from './forms/RoleForm';
import { useTeamStore } from '../../stores/teamStore';
import { Role } from '../../types/user';
import { ar } from '../../locales/ar';
import toast from 'react-hot-toast';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const AddRoleModal = ({ isOpen, onClose }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { createRole } = useTeamStore();

  const handleSubmit = async (data: Partial<Role>) => {
    setIsLoading(true);
    setError('');

    try {
      await createRole(data as Role);
      toast.success(ar.roles.messages.addSuccess);
      onClose();
    } catch (err: any) {
      setError(err.message || ar.roles.messages.addError);
      toast.error(ar.roles.messages.addError);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={ar.roles.form.title.add}>
      {error && (
        <div className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">
          {error}
        </div>
      )}
      <RoleForm
        onSubmit={handleSubmit}
        isLoading={isLoading}
      />
    </Modal>
  );
};